import React from "react";
import HeaderPrint from "../components/HeaderPrint";
import "../styles/print.stye.css";
import SignaturePrint from "../components/SignaturePrint";
import CommentPrint from "../components/CommentPrint";
import RenderValue from "../components/RenderValue";
import { calculateAge, formatDateToThai } from "../../../../../utils/date.utils";
import { thaiMonths } from "../../../../../utils/monthThai";

const Form03 = ({
  header,
  sub_header,
  title,
  send_to,
  data,
  dataReportDetail,
  dataEmployee,
}: {
  header: string;
  sub_header: string;
  title: string;
  send_to: string;
  data: any;
  dataReportDetail: any;
  dataEmployee: any;
}) => {
  const {
    day: birth_of_day,
    month: birth_of_month,
    year: birth_of_year,
  } = formatDateToThai(dataEmployee?.date_of_birth ?? null);

  const employee_age = dataEmployee?.date_of_birth
    ? calculateAge(dataEmployee.date_of_birth)
    : null;

  const {
    day: ordination_day,
    month: ordination_month,
    year: ordination_year,
  } = formatDateToThai(dataReportDetail?.condition?.ordination_date ?? null);

  // วันที่คำสั่งบรรจุแต่งตั้ง (เมื่อวันที่ เดือน พ.ศ.)
  const {
    day: appointed_day,
    month: appointed_month,
    year: appointed_year,
  } = formatDateToThai(
    dataReportDetail?.condition?.university_date_ref ?? null
  );

  const {
    day: start_leave_day,
    month: start_leave_month,
    year: start_leave_year,
  } = formatDateToThai(dataReportDetail?.main?.leave_peroid_date?.[0] ?? null);

  const {
    day: end_leave_day,
    month: end_leave_month,
    year: end_leave_year,
  } = formatDateToThai(dataReportDetail?.main?.leave_peroid_date?.[1] ?? null);
  return (
    <div>
      <HeaderPrint
        header={header}
        sub_header={sub_header}
        title={title}
        send_to={send_to}
        form_code={"บค. ๑๕"}
        data={{
          title: "วิทยาลัยพุทธศาสนานานาชาติ",
          date: data.created_date,
        }}
      />
      {/* line 1 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ข้าพเจ้า"}
          end_label={null}
          length={60}
          value={dataEmployee?.first_name}
          isParagraph={true}
        />
        {/*  */}
        <RenderValue
          start_label={"นามสกุล"}
          end_label={null}
          length={60}
          value={dataEmployee?.last_name}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"ตำแหน่ง"}
          end_label={null}
          length={60}
          value={dataEmployee?.work_history?.position_name}
          isParagraph={false}
        />
      </div>
      {/* line 2 */}
      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"เลขที่"}
          end_label={null}
          length={50}
          value={dataEmployee?.employee_no}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"สังกัด"}
          end_label={null}
          length={80}
          value={"IBSC"}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"แผนงาน"}
          end_label={null}
          length={80}
          value={dataEmployee?.department?.department_name_th}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"เกิดวันที่"}
          end_label={null}
          length={15}
          value={birth_of_day}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={35}
          value={birth_of_month?.toString() ? thaiMonths[birth_of_month] : null}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ."}
          end_label={null}
          length={20}
          value={birth_of_year}
          isParagraph={false}
        />
        <RenderValue
          start_label={null}
          end_label={"ปี ได้รับการบรรจุแต่งตั้งเป็นบุคลากรของ"}
          length={25}
          value={employee_age}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"มหาวิทยาลัย ตามคำสั่งมหาวิทยาลัยที่"}
          end_label={null}
          length={70}
          value={dataReportDetail?.condition?.university_no_ref}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เมื่อวันที่"}
          end_label={null}
          length={20}
          value={appointed_day}
          isParagraph={false}
        />
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={
            appointed_month?.toString() ? thaiMonths[appointed_month] : null
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ."}
          end_label={null}
          length={25}
          value={appointed_year}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ข้าพเจ้ายังไม่เคยอุปสมบทมาก่อน"}
          end_label={null}
          length={0}
          value={null}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"บัดนี้มีศรัทธาจะอุปสมบทในพระพุทธศาสนา ณ พัทธสีมาวัด"}
          end_label={null}
          length={105}
          value={dataReportDetail?.condition?.ordination_address}
          isParagraph={true}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ตำบล/แขวง"}
          end_label={null}
          length={60}
          value={dataReportDetail?.condition?.ordination_district_sub}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"อำเภอ/เขต"}
          end_label={null}
          length={60}
          value={dataReportDetail?.condition?.ordination_district}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"จังหวัด"}
          end_label={null}
          length={60}
          value={dataReportDetail?.condition?.ordination_province}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ในวันที่"}
          end_label={null}
          length={10}
          value={ordination_day}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={35}
          value={
            ordination_month?.toString() ? thaiMonths[ordination_month] : null
          }
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={15}
          value={ordination_year}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"และจำพรรษาอยู่ ณ วัด"}
          end_label={null}
          length={100}
          value={dataReportDetail?.condition?.buddhist_lent_at}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ตำบล/แขวง"}
          end_label={null}
          length={60}
          value={dataReportDetail?.condition?.buddhist_lent_district_sub}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"อำเภอ/เขต"}
          end_label={null}
          length={60}
          value={dataReportDetail?.condition?.buddhist_lent_district}
          isParagraph={false}
        />
        {/*  */}
        <RenderValue
          start_label={"จังหวัด"}
          end_label={null}
          length={60}
          value={dataReportDetail?.condition?.buddhist_lent_province}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"จึงขออนุญาตอุปสมบทมีกำหนด"}
          end_label={"วัน"}
          length={20}
          value={dataReportDetail?.main?.leave_day ?? null}
          isParagraph={true}
        />

        {/*  */}
        <span className="ml-4">
          <RenderValue
            start_label={"ตั้งแต่วันที่"}
            end_label={null}
            length={20}
            value={start_leave_day ?? null}
            isParagraph={false}
          />
        </span>

        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={35}
          value={start_leave_month?.toString() ? thaiMonths[start_leave_month] : null}
          isParagraph={false}
        />

        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={30}
          value={start_leave_year ?? null}
          isParagraph={false}
        />
      </div>

      <div className="w-full flex justify-start items-start space-content">
        {/*  */}
        <RenderValue
          start_label={"ถึงวันที่"}
          end_label={null}
          length={30}
          value={end_leave_day ?? null}
          isParagraph={false}
        />

        {/*  */}
        <RenderValue
          start_label={"เดือน"}
          end_label={null}
          length={40}
          value={end_leave_month?.toString() ? thaiMonths[end_leave_month] : null}
          isParagraph={false}
        />

        {/*  */}
        <RenderValue
          start_label={"พ.ศ"}
          end_label={null}
          length={35}
          value={end_leave_year ?? null}
          isParagraph={false}
        />
      </div>

      {/* signature*/}
      <div className="w-full ml-24">
        <SignaturePrint
          title={"นมัสการมาด้วยความเคารพ"}
          prefix={`(ลงชื่อ)`}
          position={""}
          isDate={false}
          isPosition={false}
          data={{}}
        />
      </div>
      <div className="w-full">
        <CommentPrint
          title={"ความเห็นของผู้บังคับบัญชาชั้นต้น"}
          isCheckBoxApprove={false}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            isApprove: data?.leave_status
              ? data.leave_status === "approve third"
              : null,
            comment: data.leave_approve_first_comment ?? "",
          }}
          lengthDot={250}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>

        <CommentPrint
          title={"คำสั่งของผู้มีอำนาจอนุญาต"}
          isCheckBoxApprove={true}
          sxTitle=""
          amountLine={2}
          isParagraph={true}
          data={{
            isApprove: data?.leave_status
              ? data.leave_status === "approve third"
              : null,
            comment: data.leave_approve_third_comment ?? "",
          }}
          lengthDot={250}
        />
        <div className="ml-48">
          <SignaturePrint
            title={""}
            prefix={`(ลงชื่อ)`}
            position={""}
            isDate={true}
            isPosition={true}
            data={{}}
          />
        </div>
      </div>
    </div>
  );
};

export default Form03;
